export const placeholderMock: {
  display_link: string;
  headline: string;
  description: string;
} = {
  description: 'Optional - add a company description',
  headline: 'Apply now!',
  display_link: 'www.gosympl.com/vacancies',
};
